/** Réglages des fonds du thème Cyber-néon (voir ../reglages.js pour la description des types). */
export const REGLAGES = {
    vitesse: {
        type: "nombre", libelle: "Vitesse de l'animation", min: 0.5, max: 2, pas: 0.1, defaut: 1, unite: "×",
        aide: "×1 est la vitesse d'origine.",
    },
    nombre: {
        type: "nombre", libelle: "Nombre d'éléments", min: 4, max: 24, pas: 1, defaut: 12,
        aide: "Traînées, tours ou impulsions selon le fond (24 au plus, pour garder l'écran léger).",
    },
    palette: {
        type: "choix", libelle: "Palette", defaut: "violet",
        options: [{valeur: "violet", libelle: "Violet et rose"}, {valeur: "cyan", libelle: "Cyan et bleu"}, {valeur: "rouge", libelle: "Rouge et orange"}],
    },
};

/** Couleurs de chaque palette : fond haut, fond bas, deux néons, couleur du soleil (haut, bas). */
export const PALETTES = {
    violet: {haut: "#0a0020", bas: "#2b0a4d", neons: ["#ff2bd6", "#27e8ff"], soleil: ["#ffe45c", "#ff2bd6"]},
    cyan: {haut: "#00131f", bas: "#012a4a", neons: ["#27e8ff", "#6a7bff"], soleil: ["#d9fbff", "#27e8ff"]},
    rouge: {haut: "#1a0005", bas: "#4a0a14", neons: ["#ff3b3b", "#ffb13b"], soleil: ["#fff1a8", "#ff3b3b"]},
};
